import React from 'react';
import EmailDetailBlock from '@/views/event_detail/EmailDetailBlock';
import {EmailEvent} from 'entities/event';

interface Props {
    eventData: EmailEvent;
}

const ChatTextSamplesModalContents = React.memo<Props>(({eventData}) => (
    <EmailDetailBlock eventData={eventData} />
));

export default ChatTextSamplesModalContents;
